export const MAX_COMPARE_COUNT = 10;

/**
 * The maximum number of side-by-side profiles to display
 *
 * Above this number, views should switch to a compare view.
 */
export const PROFILE_COMPARE_THRESHOLD = 3;
